import "./LessonsGames.css";

import { Game } from "../../../model/model";
import React from "react";

interface Props {
  games: Game[];
}
export default function LessonsGames(props: Props) {
  const { games } = props;
  return (
    <div className="lessons-games support-column">
      <h4 className="support-title">
        Leikir
        <span className="support-subtitle">Games</span>
      </h4>
      <ul>
        {games.map((game) => (
          <li key={game.link}>
            <a href={game.link} target="_blank" rel="noreferrer">
              <div>{`${game.lesson} Slide ${game.slide}: ${game.name}`}</div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
